module.exports = __webpack_public_path__ + "img/mic12.d6aafa99.jpg";